import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingSalesOrderDeleteAtom = createMutationAtomFactory(
  'trade.bookingSalesOrderDelete',
  (params: { bookingId: string; salesOrderId: string }) => ({
    tradeBookingSalesOrderDelete: {
      __args: {
        bookingId: params.bookingId,
        salesOrderId: params.salesOrderId,
      },
    },
  }),
);
